<template>
  <div
    class="accordion"
    :class="{
      'accordion--open': isOpen,
      'accordion--closed': !isOpen,
      'accordion--hide-arrow': foldOut,
    }"
    ref="accordion"
  >
    <a
      v-if="anchor"
      :id="anchor"
      :name="anchor"
      class="accordion__anchor"
    />
    <div
      class="accordion__headline"
      @click="toggleClass"
    >
      <slot name="head" />
    </div>
    <div
      class="accordion__content"
      ref="accordionContent"
    >
      <slot name="content" />
    </div>
  </div>
</template>

<script lang="ts">
  import {Options, Prop, Vue} from 'vue-property-decorator';
  import * as scrollTo from 'scroll-to';

  @Options({
    name: 'accordion',
    components: {}
  })
  export default class Accordion extends Vue {

    @Prop({default: false})
    initialOpen!: boolean;

    @Prop({default: false})
    foldOut!: boolean;

    @Prop({default: true})
    useMaxHeight!: boolean;

    @Prop()
    anchor!: string;

    isOpen: boolean = this.initialOpen || this.foldOut;

    mounted() {
      const hash = document.location.hash;
      window.addEventListener('resize', () => {
        this.resizeContent();
      });
      if (this.anchor && hash.indexOf(this.anchor) >= 0) {
        this.isOpen = true;
        const accordion : any = this.$refs.accordion;
        const accordionRect = accordion.getBoundingClientRect();
        if (accordionRect && accordionRect.top) {
          const bodyRect = document.body.getBoundingClientRect();
          const offsetTop = accordionRect.top - bodyRect.top - 70;
          scrollTo(0, offsetTop, {duration: 500});
        }
      }
    }

    resizeContent() {
      const accordionContent : any = this.$refs.accordionContent;
      if (this.useMaxHeight && this.isOpen && accordionContent.children) {
        accordionContent.style.maxHeight = accordionContent.children[0].offsetHeight + 'px';
      }
    }

    toggleClass() {
      if (this.foldOut) {
        return;
      }
      this.isOpen = !this.isOpen;
      if (!this.useMaxHeight) {
        return;
      }
      const accordionContent : any = this.$refs.accordionContent;
      if (this.isOpen && accordionContent.children) {
        accordionContent.style.maxHeight = accordionContent.children[0].offsetHeight + 'px';
      } else {
        accordionContent.style.maxHeight = '0';
      }
    }
  }
</script>
